"use strict";
/*
 * Created on 17. 7. 2019
 *
 * Copyright (c) 2019 Etnetera, a.s. All rights reserved.
 * Intended for internal use only.
 * http://www.etnetera.cz
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var immutable_1 = require("immutable");

var utils_1 = require("../../core/utils");

var OptimizationGraphData_1 = require("../model/OptimizationGraphData");

var OptimizationGraphDataConverter_1 = require("./OptimizationGraphDataConverter");
/**
 * Implementation of {@link OptimizationGraphDataConverter}.
 * @author Radek Beran
 */


var OptimizationGraphDataConverterImpl =
/*#__PURE__*/
function (_OptimizationGraphDat) {
  _inherits(OptimizationGraphDataConverterImpl, _OptimizationGraphDat);

  function OptimizationGraphDataConverterImpl() {
    _classCallCheck(this, OptimizationGraphDataConverterImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(OptimizationGraphDataConverterImpl).apply(this, arguments));
  }

  _createClass(OptimizationGraphDataConverterImpl, [{
    key: "toDocument",

    /**
     * @inheritDoc
     */
    value: function toDocument(source, conversions) {
      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var result = {};
      Object.assign(result, {
        points: conversions.asObjectArray(source, 'points', function (graphData) {
          return graphData;
        }),
        pointsInPercent: conversions.asObjectArray(source, 'pointsInPercent', function (graphData) {
          return graphData;
        }),
        actualData: source.actualData,
        optimalMargins: conversions.asObjectArray(source, 'optimalMargins', function (optimalMargin) {
          return optimalMargin;
        })
      });
      return result;
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toObject",
    value: function toObject(source, conversions) {
      return new OptimizationGraphData_1.OptimizationGraphData(OptimizationGraphData_1.OptimizationGraphData.schema.points.valueOfField(source), utils_1.Utils.isValueMissing(source.pointsInPercent) ? immutable_1.List() : OptimizationGraphData_1.OptimizationGraphData.schema.pointsInPercent.valueOfField(source), source.actualData === null || source.actualData === undefined ? null : OptimizationGraphData_1.OptimizationGraphData.schema.actualData.valueOfField(source), utils_1.Utils.isValueMissing(source.optimalMargins) ? immutable_1.List() : OptimizationGraphData_1.OptimizationGraphData.schema.optimalMargins.valueOfField(source));
    }
  }]);

  return OptimizationGraphDataConverterImpl;
}(OptimizationGraphDataConverter_1.OptimizationGraphDataConverter);

exports.OptimizationGraphDataConverterImpl = OptimizationGraphDataConverterImpl;